<template>
  <section class="locations">
    <div class="locations-container">
      <div class="locations-content">
        <div class="content-item">
          <div class="background-icon">
            <i class="fa fa-map-marker"></i>
          </div>
          <router-link :to="{ name: $t('locationsRouteName') }">
            <h2 class="content-title">{{ $t("locations") }}</h2>
          </router-link>
        </div>

        <div class="content-item">
          <div class="background-icon">
            <i class="fa fa-question"></i>
          </div>
          <router-link :to="{ name: 'anketa' }">
            <h2 class="content-title">{{ $t("survey") }}</h2>
          </router-link>
        </div>

        <div class="content-item">
          <div class="background-icon">
            <i class="fa fa-envelope-o"></i>
          </div>
          <router-link :to="{ name: $t('contactRouteName') }">
            <h2 class="content-title">{{ $t("Contact") }}</h2>
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'LocationsSection'
}
</script>

<style scoped>
.locations {
  background-color: var(--light-color);
  padding: 1% 0;
}

.locations-container {
  max-width: 100%;
  margin: 0 auto;
  padding: 20px 7% !important;
  display: flex;
  gap: 1.7rem;
  /* min-height: 200px; */
  justify-content: space-between;
}

.locations-content {
  /* flex: 1; */
  width: 100%;
  background-color: var(--secondary-color);
  border-radius: 20px;
  padding: 30px;
  display: flex;
  justify-content: space-between;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  gap: 20px;
}

.content-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  position: relative;
  /* background: linear-gradient(50deg,
      rgba(231, 236, 248, 1) 0%,
      rgba(243, 246, 252, 1) 54%,
      rgba(231, 236, 248, 1) 82%); */
  background-color: var(--light-color);
  border-radius: 15px;
  padding: 25px;
  height: 100%;
  box-shadow: 0 6px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  transition: box-shadow 0.3s ease;
  width: 100%;
}

.content-item:hover {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.content-title {
  font-size: 24px;
  color: var(--main-color);
  font-weight: 600;
  margin: 0;
  flex: 1;
  padding-bottom: 0;
}

.background-icon {
  position: absolute;
  right: 10px;
  top: 0px;
  font-size: 40px;
  opacity: 0.1;
  color: var(--main-color);
  transform: rotate(10deg);
  transition: all 0.5s ease;
}

.content-item:hover .background-icon {
  transform: rotate(15deg) scale(1.3);
  opacity: 0.2;
}

@media (max-width: 1024px) {
  .locations-container {
    flex-direction: column;
    gap: 2rem;
  }

  .locations-content {
    flex-direction: column;
    gap: 1rem;
  }
}

@media (max-width: 768px) {
  .locations {
    padding: 2rem 0;
  }

  .locations-container {
    padding: 0 1.5rem;
  }

  .locations-content {
    padding: 1rem;
  }

  .content-title {
    font-size: 1.3rem;
  }

  .content-button {
    font-size: 18px;
  }
}

@media (max-width: 480px) {
  .locations {
    padding: 2rem 0;
  }

  .locations-container {
    padding: 0 1rem;
    gap: 1.5rem;
  }

  .locations-content {
    padding: 1rem;
  }

}
</style>
